blue.ready("contact_popup", ".contact-popup__item", (item) => {
  const toggle = item.querySelector(".contact-popup__trigger");
  const close = item.querySelector(".contact-popup__close");

  if (!toggle || !close) return;

  const managePopup = (close = false) => {
    if (close) {
      item.classList.remove("is-open");
    } else {
      item.classList.toggle("is-open");
    }
  };

  toggle.addEventListener("click", (e) => {
    managePopup();
  });
  close.addEventListener("click", (e) => {
    managePopup(true);
  });
});

blue.ready(
  "contact_popup_sms_validation",
  ".contact-popup__item--text",
  (item) => {
    const input = item.querySelector(".contact-popup__form-input");
    const label = input.closest("label");
    const submit = item.querySelector(".contact-popup__form-submit");

    console.log(item)
    console.log(submit)

    class InputState {
      static #touched = false;
      static #valid = false;

      static #error = blue.meth.createElement(
        "div",
        {
          class: "error-msg",
        },
        label.dataset.error || "Invalid input"
      );

      static #handleErrors() {
        if (InputState.valid) {
          input.classList.remove("is-invalid");
          InputState.#error.remove();
          submit.removeAttribute("disabled");
        } else {
          input.classList.add("is-invalid");
          label.appendChild(InputState.#error);
          submit.setAttribute("disabled", true);
        }
      }

      static get touched() {
        return InputState.#touched;
      }

      static set touched(value) {
        InputState.#touched = value;
        InputState.validate();
      }

      static get valid() {
        return InputState.#valid;
      }

      static set valid(value) {
        InputState.#valid = value;
        InputState.#handleErrors();
      }

      static validate() {
        if (!InputState.touched) return;

        const pattern = input.getAttribute("pattern") || /^\d{10}$/;
        const regex = new RegExp(pattern);
        let isValid = false;

        if (regex.test(input.value)) isValid = true;
        InputState.valid = isValid;
      }
    }

    input.addEventListener("input", InputState.validate);
    input.addEventListener("blur", (e) => {
      e.preventDefault();
      InputState.touched = true;
    });
    submit.addEventListener("click", (e) => {
      e.preventDefault();
      InputState.touched = true;
      if (InputState.valid) {
        if (window.shareSMS) window.shareSMS();
      }
    });
  }
);
